import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useConfirmation } from '../shared/ZCard';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { getImageUrl } from './utils';

// ==================== EDIT DIALOG ====================
export function EditDialog({ photo, onClose, onSave }) {
  const feedback = useConfirmation();
  const [form, setForm] = useState({});

  useEffect(() => {
    if (photo) setForm({
      tagline: photo.tagline || photo.title || photo.caption || '',
      tagline_position: photo.tagline_position || 'below',
      date_taken: photo.date_taken || '',
      location: photo.location || '',
    });
  }, [photo]);

  const save = async () => {
    try {
      await api.put(`/photos/${photo.id}`, form);
      feedback.confirm();
      onSave(); onClose();
    } catch { feedback.fail(); }
  };

  if (!photo) return null;

  return (
    <Dialog open={!!photo} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-white/[0.02] border-white/[0.06] text-[#f0f0f5] max-w-md" aria-describedby="edit-desc">
        <DialogHeader><DialogTitle style={{ fontFamily: "'Playfair Display', serif" }}>Edit Photo</DialogTitle></DialogHeader>
        <p id="edit-desc" className="sr-only">Edit photo details</p>
        <div className="space-y-4 mt-2">
          <img src={getImageUrl(photo.url)} alt="" className="w-full max-h-40 object-contain rounded-sm" />
          <Input value={form.tagline || ''} onChange={e => setForm(p => ({ ...p, tagline: e.target.value }))}
            placeholder="Tagline" className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084] italic"
            style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="edit-tagline" />
          <div className="grid grid-cols-2 gap-3">
            <Input value={form.location || ''} onChange={e => setForm(p => ({ ...p, location: e.target.value }))}
              placeholder="Location" className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084] text-xs" data-testid="edit-location" />
            <Input type="date" value={form.date_taken || ''} onChange={e => setForm(p => ({ ...p, date_taken: e.target.value }))}
              className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] text-xs" data-testid="edit-date" />
          </div>
          {form.tagline && (
            <div className="flex gap-2">
              {['below', 'superimposed', 'none'].map(pos => (
                <button key={pos} onClick={() => setForm(p => ({ ...p, tagline_position: pos }))}
                  className={`text-xs tracking-[0.15em] uppercase px-3 py-1.5 border rounded-full transition-colors ${
                    form.tagline_position === pos ? 'border-[#6B35B8] text-[#9B6DD4] bg-[#6B35B8]/10' : 'border-white/[0.06] text-[#6b7084]'
                  }`} style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  {pos}
                </button>
              ))}
            </div>
          )}
          <div className="flex gap-2">
            <Button onClick={save} className="flex-1 bg-[#6B35B8] hover:bg-[#6B35B8]/90 text-white rounded-full" data-testid="edit-save-btn">Save</Button>
            <Button onClick={onClose} variant="ghost" className="text-[#b0b4c0] rounded-full">Cancel</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
